import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { supabase } from "../supabaseClient";

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const [errorMsg, setErrorMsg] = useState<string | null>(null);

  useEffect(() => {
    let mounted = true;

    async function finishAuth() {
      try {
        const params = new URLSearchParams(location.search);
        const redirect = params.get("redirect") || "/";
        const safeRedirect = redirect.startsWith("/") ? redirect : "/";

        // Laisse Supabase hydrater la session depuis l'URL
        const { error } = await supabase.auth.getSession();
        if (error) throw error;

        // Petit délai court pour laisser l'état auth se stabiliser
        setTimeout(() => {
          if (mounted) navigate(safeRedirect, { replace: true });
        }, 300);
      } catch (err: any) {
        if (mounted) {
          setErrorMsg(err?.message || "Impossible de finaliser la connexion.");
        }
      }
    }

    finishAuth();

    return () => {
      mounted = false;
    };
  }, [location.search, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-gray-50 dark:bg-gray-950">
      <div className="w-full max-w-md rounded-2xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 p-6 text-center">
        {errorMsg ? (
          <div className="text-sm text-red-600 dark:text-red-300">{errorMsg}</div>
        ) : (
          <div className="flex items-center justify-center gap-3 text-sm text-gray-600 dark:text-gray-300">
            <Loader2 className="h-5 w-5 animate-spin" />
            Finalisation de la connexion...
          </div>
        )}
      </div>
    </div>
  );
}